export default "__VITE_ASSET__Cz22Ur4j__"